import { Injectable } from '@angular/core';
import { AuthenticationService } from '@core-argos-angular-artifact/core';
import { TranslateService } from '@ngx-translate/core';

export interface Language {
  code: string;
  value: string;
}

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private readonly langs = ['es', 'pt_PT', 'pt_BR', 'ca', 'en', 'uk'];
  private readonly defaultLang = 'es';

  private currentLanguage: string;

  constructor(
    private readonly authService: AuthenticationService,
    private readonly translateService: TranslateService
  ) {}

  init(localeParam?: string): void {
    const storageLocales = localStorage.getItem('locales');
    let locale;
    if (localeParam) {
      locale = this.getCloserLocale(localeParam.replace(/-/g, '_'));
    } else if (storageLocales) {
      locale = this.getCloserLocale(storageLocales.replace(/-/g, '_'));
    } else {
      locale = this.getLocale();
    }

    if (this.currentLanguage !== locale) {
      this.change(locale);
    }
    this.currentLanguage = locale;
  }

  private getCloserLocale(tentativeLocale) {
    const two = 2;
    return (
      this.langs.find(lang => lang === tentativeLocale) || // pt_BR gives pt_BR
      this.langs.find(lang => lang === tentativeLocale.slice(0, two)) || // en_GB gives en
      this.langs.find(lang => lang.slice(0, two) === tentativeLocale) || // pt gives pt_PT
      this.defaultLang // de_DE gives es
    );
  }

  private getLocale(): string {
    const token = this.authService.getTokenParsed();
    let locale = token?.locale;
    if (!locale) {
      locale = this.translateService.getBrowserCultureLang();
    }
    return this.getCloserLocale(locale.replace(/-/g, '_'));
  }

  getLang(): string {
    return this.translateService.currentLang;
  }

  change(langCode: string): void {
    this.translateService.use(langCode);
  }
}
